import React from 'react';
import { injectIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import IconMenu from 'material-ui/IconMenu';
import Badge from '@material-ui/core/Badge';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton/IconButton';
import FlatButton from 'material-ui/FlatButton/FlatButton';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import Translate from 'translate';
import APPCONFIG from 'constants/Config';

import {
  logoutUser, switchLanguage, loadChannel, reloadChannelsList, changeStatusWebsocket,
  reloadChatsList, toggleApiError, updateApiStatus,
} from 'stores/actions';
import AuthService from 'services/AuthService';
import ConfigurationService from 'services/ConfigurationService'
import XService from 'services/XService';
import languageData from './languageData.json';
import AppInfoModal from '../AppInfoModal';
import SettingsModal from '../SettingsModal';
import EmailSettingsModal from '../EmailSettingsModal';

import NotificationsService from 'services/NotificationsService';

const HeaderIconButtonStyle = {
  width: '60px',
  height: '60px',
  color: '#2e6c99'
};
const HeaderIconButtonStyle2 = {
  width: '60px',
  height: '60px',
  color: '#2e6c99',
  lineHeight: '0px',
};
const HeaderButtonStyle = {
  height: 60, color: '#2e6c99'
};

class Header extends React.Component {
  constructor() {
    super();

    this.state = {
      appInfoModalOpened: false,
      settingsModalOpened: false,
      emailSettingsModalOpened: false,

      notifications: []
    }
  }

  componentDidMount() {

    const urlParams = new URLSearchParams(window.location.search);

    const xCode = urlParams.get('code')
    const xState= urlParams.get('state')
    if (xCode) {
      XService.getCode(xCode).then((response) => {
        if (response.errors) console.log('response.error', response.errors);
        console.log('sponse.data', response.data);
        this.props.history.push('/configurations/twitter');
        
        
      })
    }   

    

    this.getNotifications( true );
    this.notificationsInteval = setInterval( () => {
      this.getNotifications();
    }, 120000 )

    this.checkApiError = setInterval ( () => {
      this.checkServices();
      
    }, 240000)

  }

  componentWillUnmount() {
    clearInterval( this.notificationsInteval )
    clearInterval( this.checkApiError )
  }

  toggleAppInfoModal = () => {
    this.setState( { appInfoModalOpened: !this.state.appInfoModalOpened } )
  };
  getTutorial = () => {
    window.open(this.props.documentHelpUrl);
  };

  toggleSettingsModal = () => {
    this.setState( { settingsModalOpened: !this.state.settingsModalOpened } )
  };

  toggleEmailSettingsModal = () => {
    this.setState( { emailSettingsModalOpened: !this.state.emailSettingsModalOpened } )
  };

  getHeaderActiveBackground( url ) {
    if( url !== '/' )
      return this.props.location.pathname.indexOf( url ) !== -1 ? "rgba(153,153,153,0.4)" : null;
    else
      return this.props.location.pathname === url ? "rgba(153,153,153,0.4)" : null;
  }


  checkServices( ) {
    ConfigurationService.getComponentStatus().then( ( response ) => {
      if( response.errors ) return cb( null, {  
        dbStatus: {status: 'KO', statusDay: 0 },
        whatsappStatus: {status: 'KO', statusDay: 0 },
        incmsApiObj: {status: 'KO', statusDay: 0 },
        facebookStatus: {status: 'KO', statusDay: 0 },
        twitterStatus: {status: 'KO', statusDay: 0 },
        emailStatus: {status: 'KO', statusDay: 0 },
        smsStatus: {status: 'KO', statusDay: 0 }, 
      }  );
      const whatsappStatus = _.find(response.data.data, { 'code': 'whatsapp_status'});
      const dbStatus = _.find(response.data.data, { 'code': 'db_status'});
      const incmsStatus = _.find(response.data.data, { 'code': 'incms_status'});
      const facebookStatus = _.find(response.data.data, { 'code': 'facebook_status'});
      const twitterStatus = _.find(response.data.data, { 'code': 'twitter_status'});
      const emailStatus = _.find(response.data.data, { 'code': 'email_status'});
      //const smsStatus = _.find(response.data.data, { 'code': 'sms_status'});

      this.props.updateApiStatus( {
        dbStatus: dbStatus && dbStatus.status ? dbStatus.status : 'KO' ,
        whatsappStatus: whatsappStatus && whatsappStatus.status ? whatsappStatus.status : 'KO',
        incmsApiStatus: incmsStatus && incmsStatus.status ? incmsStatus.status : 'KO',
        facebookStatus: facebookStatus && facebookStatus.status ? facebookStatus.status : 'KO' ,
        twitterStatus: twitterStatus && twitterStatus.status ? twitterStatus.status : 'KO' ,
        emailStatus:  emailStatus && emailStatus.status ? emailStatus.status : 'KO' ,
        phoneStatus: 'OK',
      } );

      let message = '';
      if (incmsStatus.status === 'KO') {
        message += ' - External Api,'
      }
      
      if (dbStatus.status === 'KO') {
        message += ' - Database,'
      }
      //if (whatsappStatus.status === 'KO') {
      //  message += 'Whatsapp,'
      //}
      if (facebookStatus.status === 'KO') {
        message += ' - Facebook'
      }
      if (twitterStatus.status === 'KO') {
        message += ' - Twitter'
      }
      if (emailStatus.status === 'KO') {
        message += ' - Email'
      }
      //if ( smsStatus.status === 'KO') {
      //  message += ' - SMS'
      //}
      if ( message !== '' ) {
        message += ' ';
        message = 'The following services have problems:' + message;
      }
      this.props.toggleApiError( message )
    } );
  }
  getNotifications( firstTime = false ) {
    NotificationsService.getNotifications( { limit: 0, offset: 0, 'filters[status]': 'created' } )
      .then( ( response ) => {
        if( !response.errors ) {
          if( this.props.location.pathname === '/agent' && !firstTime ) {
            const assigmentChannelNotifications = _.filter( response.data.data, {
              type: 'assigment',
              content: 'assigned_channel'
            } );
            if( assigmentChannelNotifications && assigmentChannelNotifications.length ) {
              this.props.reloadChannelsList()
            }

            const assigmentChatNotifications = _.filter( response.data.data, {
              type: 'assigment',
              content: 'assigned_chat_channel'
            } );
            if( assigmentChatNotifications && assigmentChatNotifications.length ) {
              this.props.reloadChatsList()
            }
          }
          this.setState( { notifications: _.filter( response.data.data, { type: 'update' } ) } )
        }
      } )
  }

  readNotification( item ) {
    if( this.props.location.pathname !== '/agent' ) {
      this.props.history.push( '/agent' );
    }
    if( _.get( item, 'channel.id' ) ) {
      this.props.loadChannel( item.channel.id )
    }

    NotificationsService.readNotifications( { ids: item.id } )
      .then( ( response ) => {
        if( !response.errors ) {
          this.setState( {
            notifications: _.filter(
              this.state.notifications, notification => notification.type === 'update' && notification.id !== item.id )
          } )
        }
      } )
  }

  render() {
    const { locale, apiStatus, apiErrorMessage, fullName, languageEnabled, externalAuthenticationRequired, username, userExternalAuthentication, reportActive, intl, externalCustomer } = this.props;
    const { appInfoModalOpened, settingsModalOpened, emailSettingsModalOpened } = this.state;

    let changePasswordUrl = '';
    switch( process.env.NODE_ENV ) {
      case 'development':
        changePasswordUrl = APPCONFIG.DEVchangePasswordUrl;
        break;
      case 'production':
        changePasswordUrl = APPCONFIG.PROchangePasswordUrl;
        break;
      case 'qa':
        changePasswordUrl = APPCONFIG.QAchangePasswordUrl;
        break;
    }
    return (
      <section className="app-header">
        <div className="app-header-inner bg-color-white row m-0">
          <div className="brand d-flex align-items-center full-height col-auto navbar-brand">
            <Link to="/">
              <img src="assets/images/logo_smm_minsait.png" width={180}/>
            </Link>
          </div>

          <div className="top-nav-left full-height col">
            <ul className="list-unstyled list-inline d-xl-none text-left">
              <li>
                <IconMenu
                  iconButtonElement={
                    <IconButton style={HeaderIconButtonStyle} className="md-button header-btn">
                      <i className="material-icons">menu</i>
                    </IconButton>}
                  onChange={this.handleChange}
                  anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                  targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                  menuStyle={{ minWidth: '230px' }}
                >
                  <MenuItem
                    onClick={() => this.props.history.push( '/' )}
                    primaryText={<Translate id="navigation.dashboard"/>}
                    style={{
                      fontSize: '14px',
                      color: '#333333',
                      backgroundColor: this.getHeaderActiveBackground( '/' )
                    }}
                    innerDivStyle={{ padding: '0px 16px 0px 45px' }}
                  />
                  <MenuItem
                    onClick={() => this.props.history.push( '/agent' )}
                    primaryText={<Translate id="navigation.agent"/>}
                    style={{
                      fontSize: '14px',
                      color: '#333333',
                      backgroundColor: this.getHeaderActiveBackground( '/agent' )
                    }}
                    innerDivStyle={{ padding: '0px 16px 0px 45px' }}
                  />
                  {( AuthService.getUserRole().isBroadcast || AuthService.getUserRole().isAdmin ) &&
                  <MenuItem
                    onClick={() => this.props.history.push( '/broadcast/facebook' )}
                    primaryText={<Translate id="navigation.broadcast"/>}
                    style={{
                      fontSize: '14px',
                      color: '#333333',
                      backgroundColor: this.getHeaderActiveBackground( '/broadcast' )
                    }}
                    innerDivStyle={{ padding: '0px 16px 0px 45px' }}
                  />
                  }
                  {( AuthService.getUserRole().isTechAdmin || AuthService.getUserRole().isFunctAdmin || AuthService.getUserRole().isAdmin ) &&
                  <MenuItem
                    onClick={() => this.props.history.push( '/configurations/facebook' )}
                    primaryText={<Translate id="navigation.configuration"/>}
                    style={{
                      fontSize: '14px',
                      color: '#333333',
                      backgroundColor: this.getHeaderActiveBackground( '/configurations' )
                    }}
                    innerDivStyle={{ padding: '0px 16px 0px 45px' }}
                  />
                  }
                  {( AuthService.getUserRole().isSupervisor || AuthService.getUserRole().isTechAdmin || AuthService.getUserRole().isAdmin ) &&
                  <MenuItem
                    onClick={() => this.props.history.push( '/management/status' )}
                    primaryText={<Translate id="navigation.management"/>}
                    style={{
                      fontSize: '14px',
                      color: '#333333',
                      backgroundColor: this.getHeaderActiveBackground( '/management' )
                    }}
                    innerDivStyle={{ padding: '0px 16px 0px 45px' }}
                  />
                  }
                </IconMenu>
              </li>
            </ul>

            <ul className="list-unstyled list-inline align-items-center full-height d-none d-xl-flex">
              <li className="list-inline-item pointer mdl-animation--fast-out-linear-in d-none d-xl-inline"
                  onClick={() => {}}>
                <FlatButton style={HeaderButtonStyle} label={<Translate id="navigation.dashboard"/>}
                            backgroundColor={this.getHeaderActiveBackground( '/' )}
                            onClick={() => {this.props.history.push( '/' )}}/>
              </li>
              <li className="list-inline-item pointer d-none d-xl-inline">
                <FlatButton style={HeaderButtonStyle}
                            label={<Translate id="navigation.agent"/>}
                            backgroundColor={this.getHeaderActiveBackground( '/agent' )}
                            onClick={() => {this.props.history.push( '/agent' )}}/>
                {( AuthService.getUserRole().isBroadcast || AuthService.getUserRole().isAdmin ) &&
                <FlatButton style={HeaderButtonStyle}
                            label={<Translate id="navigation.broadcast"/>}
                            backgroundColor={this.getHeaderActiveBackground( '/broadcast' )}
                            onClick={() => {this.props.history.push( '/broadcast/facebook' )}}/>
                }
                
                { ((!!reportActive) &&
                  (AuthService.getUserRole().isReport ||
                  AuthService.getUserRole().isAdmin)) && (
                  <IconMenu
                    iconButtonElement={
                      <FlatButton
                        style={HeaderButtonStyle}
                        label={<Translate id="navigation.report" />}
                      />
                    }
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                    menuStyle={{ minWidth: '250px' }}
                  >
                    <MenuItem
                      className="header-icon-dropdown-item"
                      primaryText={
                        <Translate id="report.executiveSummaryReport" />
                      }
                      backgroundColor={this.getHeaderActiveBackground(
                        '/report/executiveSummaryReport'
                      )}
                      onClick={() => {
                        this.props.history.push(
                          '/report/executiveSummaryReport'
                        );
                      }}
                    />
                    <MenuItem
                      className="header-icon-dropdown-item"
                      primaryText={
                        <Translate id="report.activityByUserReport" />
                      }
                      backgroundColor={this.getHeaderActiveBackground(
                        '/report/activityByUserReport'
                      )}
                      onClick={() => {
                        this.props.history.push('/report/activityByUserReport');
                      }}
                    />
                    <MenuItem
                      className="header-icon-dropdown-item"
                      primaryText={
                        <Translate id="report.executivePerUserReport" />
                      }
                      backgroundColor={this.getHeaderActiveBackground(
                        '/report/executivePerUserReport'
                      )}
                      onClick={() => {
                        this.props.history.push(
                          '/report/executivePerUserReport'
                        );
                      }}
                    />

                    <MenuItem
                      className="header-icon-dropdown-item"
                      primaryText={
                        <Translate id="report.entriesPerHours" />
                      }
                      backgroundColor={this.getHeaderActiveBackground(
                        '/report/entriesPerHours'
                      )}
                      onClick={() => {
                        this.props.history.push(
                          '/report/entriesPerHours'
                        );
                      }}
                    />

                    <MenuItem
                      className="header-icon-dropdown-item"
                      primaryText={
                        <Translate id="report.entriesByCategory" />
                      }
                      backgroundColor={this.getHeaderActiveBackground(
                        '/report/entriesByCategory'
                      )}
                      onClick={() => {
                        this.props.history.push(
                          '/report/entriesByCategory'
                        );
                      }}
                    />

                    <MenuItem
                      className="header-icon-dropdown-item"
                      primaryText={
                        <Translate id="report.entriesDismissed" />
                      }
                      backgroundColor={this.getHeaderActiveBackground(
                        '/report/entriesDismissed'
                      )}
                      onClick={() => {
                        this.props.history.push(
                          '/report/entriesDismissed'
                        );
                      }}
                    />

                    <MenuItem
                      className="header-icon-dropdown-item"
                      primaryText={
                        <Translate id="report.uptimeReport" />
                      }
                      backgroundColor={this.getHeaderActiveBackground(
                        '/report/uptimeReport'
                      )}
                      onClick={() => {
                        this.props.history.push(
                          '/report/uptimeReport'
                        );
                      }}
                    />
                  </IconMenu>

                  
                )}
                {( AuthService.getUserRole().isTechAdmin || AuthService.getUserRole().isFunctAdmin || AuthService.getUserRole().isAdmin ) &&
                <FlatButton style={HeaderButtonStyle}
                            label={<Translate id="navigation.configuration"/>}
                            backgroundColor={this.getHeaderActiveBackground( '/configurations' )}
                            onClick={() => {this.props.history.push( '/configurations/facebook' )}}/>
                }
                {( AuthService.getUserRole().isSupervisor || AuthService.getUserRole().isTechAdmin || AuthService.getUserRole().isAdmin ) &&
                <FlatButton style={HeaderButtonStyle}
                            label={<Translate id="navigation.management"/>}
                            backgroundColor={this.getHeaderActiveBackground( '/management' )}
                            onClick={() => {this.props.history.push( '/management/status' )}}/>
                }
              </li>
            </ul>
          </div>

          <div className="top-nav-right col-auto">
            <ul className="list-unstyled list-inline">
              {languageEnabled ?
                <li className="list-inline-item">
                  <IconMenu
                    iconButtonElement={<IconButton
                      style={HeaderIconButtonStyle}
                      className="md-button header-btn">
                      <i data-tip={intl.formatMessage( { id: "iconMenu.language" } )} className={`flag flag-24 flag-${locale.icon==='pt' ? 'br' : locale.icon}`}/>
                      <ReactTooltip place="bottom" type="dark" effect="solid"/>
                      <span className="badge">3</span>
                    </IconButton>}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                    menuStyle={{ minWidth: '200px' }}
                  >
                    {languageData.map( locale => {
                      return <MenuItem
                        key={locale.languageId}
                        className="header-icon-dropdown-item"
                        primaryText={<div className="align-middle d-inline-block border-bottom">
                          <Translate id={`language.${locale.languageId}`}/>
                        </div>}
                        leftIcon={<i
                          className={`mr-4 d-inline-block align-middle flag flag-24 flag-${locale.icon==='pt' ? 'br' : locale.icon}`}/>}
                        onClick={() => this.props.switchLanguage( locale )}
                      />
                    } )}
                  </IconMenu>
                </li> : null
              }

              <li className="list-inline-item">
                <IconButton style={HeaderIconButtonStyle} className="md-button header-btn"
                            onClick={this.toggleAppInfoModal}>
                  {apiStatus.incmsApiStatus === 'KO' ?
                    <i data-tip={intl.formatMessage( { id: "iconMenu.about" } )} className="material-icons header-color-danger">warning</i>
                    : <i data-tip={intl.formatMessage( { id: "iconMenu.about" } )} className="material-icons">info_outline</i>}
                    <ReactTooltip place="bottom" type="dark" effect="solid"/>
                </IconButton>
              </li>

              <li className="list-inline-item">
                <IconMenu
                  iconButtonElement={
                    
                    <IconButton
                      style={HeaderIconButtonStyle2}
                      className="md-button header-btn">
                      {!this.state.notifications.length ?
                      <i data-tip={intl.formatMessage( { id: "iconMenu.notifications" } )} className="material-icons">notifications_none</i>
                      :
                      <Badge badgeContent=" " color="secondary" variant="dot">
                      <i data-tip={intl.formatMessage( { id: "iconMenu.notifications" } )} className="material-icons">notifications_none</i>
                      </Badge>


                      }
                      <ReactTooltip place="bottom" type="dark" effect="solid"/>
                    </IconButton>
                    
                    
                    }
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                  menuStyle={{ width: '350px', height: 300, overflow: 'auto' }}
                >
                  {!this.state.notifications.length ?
                    <div className="text-center p-5 text-muted">
                      <i className="fa fa-exclamation-circle fa-3x"/>
                      <h4>
                        <Translate id="noNotifications"/>
                      </h4>
                    </div> : null}
                  {_.map( this.state.notifications, item => (
                    <MenuItem
                      key={item.id}
                      style={{ lineHeight: 1.5, minHeight: 'auto', padding: '6px 0' }}
                      className="header-icon-dropdown-item"
                      leftIcon={<i className="material-icons" style={{ margin: '0 12px' }}>mail_outline</i>}
                      onClick={() => this.readNotification( item )}
                      primaryText={
                        <div style={{ whiteSpace: 'normal', lineHeight: 1.5 }}>
                          {`Channel ${_.get( item, 'channel.name', '' )} updated`}
                          <div className="text-muted">
                            {item.createdAt ? moment( item.createdAt ).format( 'DD/MM/YY hh:MM A' ) : ''}
                          </div>
                        </div>}
                    />
                  ) )}
                </IconMenu>
              </li>

              <li className="list-inline-item">
                <IconButton style={HeaderIconButtonStyle} className="md-button header-btn"
                            onClick={this.getTutorial}>
                    <i data-tip={intl.formatMessage( { id: "iconMenu.userManual" } )} className="material-icons">help_outline</i>
                    <ReactTooltip place="bottom" type="dark" effect="solid"/>
                </IconButton>
              </li>

              <li>
                <IconMenu
                  iconButtonElement={
                    <IconButton style={HeaderIconButtonStyle}>
                      <img data-tip={intl.formatMessage( { id: "iconMenu.profile" } )} src="assets/images/icons/user.png" className="rounded-circle img30_30"/>
                    </IconButton>}
                  onChange={this.handleChange}
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                  menuStyle={{ minWidth: '230px' }}
                >
                  <MenuItem
                    primaryText={<span><i className="icon-headset mr-2 color-purple"/>{fullName}</span>}
                    style={{
                      fontSize: '14px',
                      fontWeight: 500,
                      color: '#333333',
                      lineHeight: '35px',
                      minHeight: '35px'
                    }}
                  />
                  <div className="divider divider-solid my-1"/>
                  <MenuItem
                    onClick={this.toggleSettingsModal}
                    primaryText={<Translate id="navigation.setting"/>}
                    style={{ fontSize: '14px', color: '#333333' }}
                    innerDivStyle={{ padding: '0px 16px 0px 45px' }}
                    leftIcon={<i className="icon-cog" style={{ top: -11 }}/>}
                  />
                  {externalCustomer === 'kplc' &&
                    <MenuItem
                      onClick={this.toggleEmailSettingsModal}
                      primaryText={<Translate id="navigation.emailSetting"/>}
                      style={{ fontSize: '14px', color: '#333333' }}
                      innerDivStyle={{ padding: '0px 16px 0px 45px' }}
                      leftIcon={<i style={{ top: -8 }}>
                        <svg fill="#333333" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 64 64" width="18px" height="18px">
                            <path d="M 35.136719 2.386719 C 34.917969 2.378906 34.699219 2.390625 34.480469 2.429688 L 5.304688 7.578125 C 3.390625 7.917969 2 9.574219 2 11.515625 L 2 50.484375 C 2 52.425781 3.390625 54.085938 5.304688 54.421875 L 34.480469 59.570313 C 34.652344 59.601563 34.828125 59.613281 35 59.613281 C 35.699219 59.613281 36.382813 59.371094 36.929688 58.910156 C 37.609375 58.34375 38 57.503906 38 56.613281 L 38 52 L 57 52 C 58.652344 52 60 50.652344 60 49 L 60 13 C 60 11.347656 58.652344 10 57 10 L 38 10 L 38 5.382813 C 38 4.496094 37.609375 3.65625 36.929688 3.085938 C 36.417969 2.65625 35.789063 2.414063 35.136719 2.386719 Z M 35.101563 4.390625 C 35.355469 4.414063 35.542969 4.53125 35.640625 4.617188 C 35.777344 4.730469 36 4.980469 36 5.382813 L 36 56.613281 C 36 57.019531 35.777344 57.269531 35.640625 57.382813 C 35.507813 57.496094 35.21875 57.671875 34.828125 57.601563 L 5.652344 52.453125 C 4.695313 52.285156 4 51.457031 4 50.484375 L 4 11.515625 C 4 10.542969 4.695313 9.714844 5.652344 9.546875 L 34.828125 4.398438 C 34.925781 4.382813 35.015625 4.378906 35.101563 4.390625 Z M 38 12 L 57 12 C 57.550781 12 58 12.449219 58 13 L 58 49 C 58 49.550781 57.550781 50 57 50 L 38 50 L 38 40.484375 L 43.78125 34.703125 C 44.171875 34.316406 44.171875 33.683594 43.78125 33.292969 C 43.386719 32.902344 42.757813 32.902344 42.363281 33.292969 L 38 37.65625 L 38 26.34375 L 46.34375 18 L 52 18 L 52 23.65625 L 47.363281 28.292969 C 46.972656 28.683594 46.972656 29.3125 47.363281 29.703125 C 47.558594 29.898438 47.816406 30 48.074219 30 C 48.328125 30 48.585938 29.898438 48.78125 29.703125 L 53.707031 24.777344 C 53.898438 24.589844 54 24.335938 54 24.070313 L 54 17 C 54 16.449219 53.554688 16 53 16 L 45.933594 16 C 45.664063 16 45.410156 16.105469 45.222656 16.292969 L 38 23.515625 Z M 16 20 C 14.898438 20 14 20.898438 14 22 L 14 40 C 14 41.101563 14.898438 42 16 42 L 25 42 C 25.554688 42 26 41.550781 26 41 C 26 40.449219 25.554688 40 25 40 L 16 40 L 16 32 L 23 32 C 23.554688 32 24 31.550781 24 31 C 24 30.449219 23.554688 30 23 30 L 16 30 L 16 22 L 25 22 C 25.554688 22 26 21.550781 26 21 C 26 20.449219 25.554688 20 25 20 Z M 41.996094 25.921875 C 41.742188 25.921875 41.484375 26.023438 41.289063 26.21875 C 40.898438 26.609375 40.898438 27.242188 41.289063 27.632813 L 52 38.34375 L 52 44 L 46.34375 44 L 41.707031 39.363281 C 41.316406 38.972656 40.6875 38.972656 40.296875 39.363281 C 39.902344 39.753906 39.902344 40.386719 40.296875 40.777344 L 45.222656 45.703125 C 45.414063 45.894531 45.664063 46 45.933594 46 L 53 46 C 53.554688 46 54 45.550781 54 45 L 54 37.925781 C 54 37.664063 53.898438 37.40625 53.707031 37.21875 L 42.703125 26.21875 C 42.507813 26.023438 42.25 25.921875 41.996094 25.921875 Z"/>
                        </svg>
                      </i>}
                    />
                  }
                  <MenuItem
                    onClick={() => externalAuthenticationRequired || userExternalAuthentication
                      ? window.open( `${changePasswordUrl}?LN=${username || ''}`, '_blank' )
                      : this.props.history.push( '/change-password' )}
                    primaryText={<Translate id="navigation.changePassword"/>}
                    style={{ fontSize: '14px', color: '#333333' }}
                    innerDivStyle={{ padding: '0px 16px 0px 45px' }}
                    leftIcon={<i className="icon-lock" style={{ top: -11 }}/>}
                  />
                  <MenuItem
                    onClick={() => {
                      this.props.logoutUser();
                      this.props.changeStatusWebsocket( { status: 'off' } );
                      this.props.history.push( '/login' )
                    }}
                    primaryText={<Translate id="navigation.logout"/>}
                    style={{ fontSize: '14px', color: '#333333' }}
                    innerDivStyle={{ padding: '0px 16px 0px 45px' }}
                    leftIcon={<i className="icon-logout" style={{ top: -11 }}/>}
                  />
                  <div className="divider divider-solid my-1"/>
                  <MenuItem
                    primaryText={<span><Translate id="navigation.env"/>: {process.env.NODE_ENV}</span>}
                    style={{
                      fontSize: '14px',
                      color: '#888888',
                      fontWeight: 300,
                      fontStyle: 'italic',
                      lineHeight: '30px',
                      minHeight: '30px'
                    }}
                    innerDivStyle={{ padding: 0, textAlign: 'center' }}
                  />
                </IconMenu>
              </li>
            </ul>
          </div>
        </div>

        <AppInfoModal open={appInfoModalOpened}
                      onClose={this.toggleAppInfoModal}
        />

        <SettingsModal open={settingsModalOpened}
                       onClose={this.toggleSettingsModal}
        />

        <EmailSettingsModal open={emailSettingsModalOpened}
                       onClose={this.toggleEmailSettingsModal}
        />

      </section>
    );
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  apiErrorMessage: state.settings.apiErrorMessage,
  locale: state.settings.locale,
  apiStatus: state.settings.apiStatus,
  documentHelpUrl: state.settings.documentHelpUrl,
  languageEnabled: state.user.languageEnabled,
  reportActive: state.settings.reportActive,
  username: state.user.username,
  externalCustomer: state.settings.externalCustomer,
  userExternalAuthentication: state.user.externalAuthentication,
  fullName: `${state.user.name || '---'} ${state.user.lastname || ''}`,
  externalAuthenticationRequired: state.settings.externalAuthenticationRequired,
} );

const mapDispatchToProps = dispatch => ( {
  logoutUser: () => {
    dispatch( logoutUser() );
  },
  switchLanguage: ( locale ) => {
    dispatch( switchLanguage( locale ) );
  },
  loadChannel: ( id ) => {
    dispatch( loadChannel( id ) );
  },
  reloadChannelsList: () => {
    dispatch( reloadChannelsList() );
  },
  reloadChatsList: () => {
    dispatch( reloadChatsList() );
  },
  changeStatusWebsocket: ( data ) => {
    dispatch( changeStatusWebsocket( data ) );
  },
  toggleApiError: ( apiErrorMessage ) => {
    dispatch( toggleApiError( apiErrorMessage ) );
  },
  updateApiStatus: ( data ) => {
    dispatch( updateApiStatus( data ) );
  },
} );

module.exports = withRouter( connect(
  mapStateToProps,
  mapDispatchToProps
)( injectIntl( Header ) ) );



// WEBPACK FOOTER //
// ./routes/app/components/Navigation/Header/index.js